/**
 * @generated SignedSource<<993d3cd8e2f5148020ff633f4c235393>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_item$data = {
  readonly hasShipmentQuotes: boolean | null;
  readonly itemIsOnHold: boolean | null;
  readonly hasPrivateListing: boolean | null;
  readonly attributes: {
    readonly leadTime: ReadonlyArray<{
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item">;
  readonly " $fragmentType": "PdpSharedShippingInfoLink_item";
};
export type PdpSharedShippingInfoLink_item$key = {
  readonly " $data"?: PdpSharedShippingInfoLink_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShipmentQuotes",
      "storageKey": null
    },
    {
      "alias": "itemIsOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "86b5726e1bf8e578a8ed0a2e0cc73145";

export default node;
